module.exports = __webpack_public_path__ + "static/img/pic-cnt-active-4.51bfb12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-active-4.png
// module id = D0Nt
// module chunks = 0